import React from 'react';

import { Container, Content } from './styles';

const Area: React.FC<{ children?: React.ReactNode }> = ({ children }) => {
  return (
    <Container>
      <Content>
        <>{children}</>
      </Content>
    </Container>
  );
};

export default Area;
